import { CreditScoreIcon } from "../../../atoms/icons/credit-score";
import React from "react";

export const CreditScore = ({ creditScore }) => {
  return (
    <div className="irq-nav-wrapper">
      <CreditScoreIcon className="margin-right" fill="white" />
      <span className="top-stats-text">Credit Score:</span>
      <div className="margin-left">
        <span className="large bold">{creditScore}</span>
      </div>
    </div>
  );
};
